export const IS_LOCAL = process.env.VUE_APP_IS_LOCAL === 'true'
export const API_NAME = 'kamerker2API'
export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || ''
export const GOOGLE_MAPS_API_VERSION = 3

export const SITE_NAME = process.env.VUE_APP_SITE_NAME || 'KAMEKER3'
export const MAIN_COLOR = process.env.VUE_APP_MAIN_COLOR || '#003076'

export const DISPLAY_TYPE_MAP = 'map'
export const DISPLAY_TYPE_LIST = 'list'
